enum InternalModules {
  ScreeningCenter = 'fsc',
  Siu = 'siu'
}
export default InternalModules;
